// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  performanceReportsPlantStatusSubRoute,
  PLANT_STATUS_SUB_PATH
} from '@features/performance-reports'
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {STOPPAGE_ANALYSIS_SUB_PATH, stoppageAnalysisSubRoute} from '@features/stoppage-analysis'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {
  buildFeatureUrl,
  useSuiteHierarchyId,
  useUpmPlantFromHierarchyId
} from '@hproduce/suite-core'
import {CircularProgress, ThemeProvider} from '@mui/material'
import {useUpmHierarchyAreaNavigation} from '@widgets/area-dashboard'
import {Suspense} from 'react'
import {generatePath, RouteObject, useNavigate} from 'react-router'

import {reliabilityEngineerDashboardFeatureTranslations} from '../localization'
import {ReliabilityEngineerAreaDashboard, ReliabilityEngineerPlantDashboard} from '../pages'
import {getRcfaListUrl, getShiftEventsWorkOrdersUrl} from '../utils'

const FEATURE_NAME = 'ReliabilityEngineerDashboard'

const SuiteReliabilityEngineerDashboard = () => {
  const upmPlant = useUpmPlantFromHierarchyId()
  const navigate = useNavigate()

  if (!upmPlant) {
    return null
  }

  const rcfaListUrl = getRcfaListUrl(upmPlant.upmId)
  const workOrdersHref = getShiftEventsWorkOrdersUrl(upmPlant.upmId)

  const navigateToStoppageAnalysis = (equipmentId: string) => {
    void navigate(generatePath(STOPPAGE_ANALYSIS_SUB_PATH, {equipmentId}))
  }

  // TODO: add navigation for myTasks
  return (
    <ReliabilityEngineerPlantDashboard
      plantId={upmPlant.plantId}
      maintainHref={rcfaListUrl}
      cockpitWorkOrdersHref={workOrdersHref}
      plantStatusPageHref={PLANT_STATUS_SUB_PATH}
      onEquipmentClick={navigateToStoppageAnalysis}
    />
  )
}

const SuiteReliabilityEngineerAreaDashboard = () => {
  const hierarchyId = useSuiteHierarchyId()
  const navigation = useUpmHierarchyAreaNavigation({
    upmAreaId: hierarchyId ?? undefined,
    getNodeLink: (upmHierarchyId) => buildFeatureUrl(FEATURE_NAME, upmHierarchyId)
  })

  return (
    <ReliabilityEngineerAreaDashboard
      dashboardRoute={buildFeatureUrl(FEATURE_NAME)}
      navigation={navigation}
    />
  )
}

const SuiteReliabilityEngineerNodeDashboard = () => {
  const plant = useUpmPlantFromHierarchyId()

  if (plant === undefined) {
    return null
  }

  return plant ? <SuiteReliabilityEngineerDashboard /> : <SuiteReliabilityEngineerAreaDashboard />
}

const SuiteReliabilityEngineerDashboardRouteWrapper = () => {
  return (
    <FeatureTranslationsLoader translations={reliabilityEngineerDashboardFeatureTranslations}>
      <ThemeProvider theme={useFundamentalMuiTheme()}>
        <Suspense fallback={<CircularProgress color="secondary" size={80} />}>
          <SuiteReliabilityEngineerNodeDashboard />
        </Suspense>
      </ThemeProvider>
    </FeatureTranslationsLoader>
  )
}

export const reliabilityEngineerDashboardRoute: RouteObject = {
  path: '*',
  children: [
    {
      index: true,
      element: <SuiteReliabilityEngineerDashboardRouteWrapper />
    },
    performanceReportsPlantStatusSubRoute,
    stoppageAnalysisSubRoute
  ]
}
